export const applyBackgroundImage = (bg, url, homeScreenPhotoDarkening = 0) => {
  if (!url) {
    bg.style.background = "";
    return;
  }
  const img = new Image();
  img.onload = () => {
    bg.style.background = `
      linear-gradient(
        rgba(0, 0, 0, ${homeScreenPhotoDarkening}),
        rgba(0, 0, 0, ${homeScreenPhotoDarkening})
      ),
      url("${url}")
    `;
    bg.style.backgroundSize = "cover";
    bg.style.backgroundPosition = "center";
    bg.style.backgroundRepeat = "no-repeat";
  };
  img.src = url;
};